import { Component, Input, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { AuthServiceService } from 'src/app/shareModule/services/auth-service.service';
import { MarketplaceBottomBannerComponent } from '../../marketplace/bottom-banner/marketplace-bottom-banner.component';
import { CommonService } from 'src/app/shareModule/services/common.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ApiResponse } from 'src/app/shareModule/models/common.model';
import { ToastrService } from 'ngx-toastr';
import { environment } from '../../../../environments/environment';
import moment from 'moment';
import { LocalServiceService } from 'src/app/shareModule/services/local-service.service';
import { AppState } from 'src/app/shareModule/states/app.state';
import { select, Store } from '@ngrx/store';
import { selectAllCommunityProductCategory } from 'src/app/shareModule/states/community-product-category';
import { Subject, takeUntil } from 'rxjs';
@Component({
  selector: 'community-articles-carsouel',
  templateUrl: './articles-carsouel.component.html',
  styleUrls: ['./articles-carsouel.component.scss']
})
export class ArticlesCarsouelComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();
  @Input() title: boolean = true;
  @Input() grid: string = '';
  @Input() adminMode: boolean = false;
  @ViewChild('AssignOption') AssignModal: MarketplaceBottomBannerComponent;

  @Input() carouselOptions: any = {
    spaceBetween: 10,
    slidesPerView: 2,
    breakpoints: {
      640: {
        slidesPerView: 2,
      },
      768: {
        slidesPerView: 3,
      },
      1024: {
        slidesPerView: 4,
      }
    }
  }
  public banners: any = {};
  public pageSize = 100;
  public totalPage = [];
  public categoriesList: Array<any> = [];
  public subRegionList: Array<any> = [];
  public selectedArticle: any = null;
  public commonModal: any = null;
  public imgUrl = environment.ImageUrl;
  loading: boolean = false;

  constructor(
    private auth: AuthServiceService,
    public commonService: CommonService,
    private modalService: NgbModal,
    private toastr: ToastrService,
    private store: Store<AppState>,
    private local: LocalServiceService
  ) { }

  ngOnInit(): void {
    this.loading = true;
    this.getArticlesList(1, '', '');
    this._getAllMemberShopCategoriesList();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  public getArticlesList(page, memberShopCategory: string, memberShopSubRegion: string) {
    if (memberShopCategory || memberShopSubRegion) {
      this.auth.getArticlesList(page, 0, 'SG News', this.pageSize, true)
        .pipe(takeUntil(this.destroy$))
        .subscribe(
          (response: any) => {
            this.banners = response.body;
            this.loading = false;
          }, (e) => {
            this.loading = false;
          }
        );
    } else {
      this.loading = false;
      this.banners.data = [];
    }
  }

  private _getAllMemberShopCategoriesList(): void {

    this.store
      .pipe(select(selectAllCommunityProductCategory), takeUntil(this.destroy$))
      .subscribe((list: any) => {
        let response = structuredClone(list);
        let output = response.map(i => {
          let output = i;
          output['checked'] = false;
          return output;
        })
        this.categoriesList = this.commonService.removeDuplicateAndCombineByProp(output, 'name');
      });
  }

  public assign(selectedArticle) {
    this.categoriesList = this.categoriesList.map((i: any) => {
      let output = i;
      output['checked'] = selectedArticle.memberShopCategory ? selectedArticle.memberShopCategory.includes(i.name ? i.name : '') : false;
      return output;
    });

    let selectedId = selectedArticle.memberShopSubRegion ? selectedArticle.memberShopSubRegion.split('|') : [];

    this.subRegionList = structuredClone(this.commonService.subRegionLists.map((j) => {
      let output = JSON.parse(JSON.stringify(j));
      output['checked'] = selectedId.includes(j.subRegionId.toString());
      return output;
    }));

    this.selectedArticle = selectedArticle;
    this.commonModal = this.modalService.open(this.AssignModal, { size: 'sm', ariaLabelledBy: 'modal-basic-title' })
  }

  assignArticles() {
    if (this.selectedArticle) {
      let categoryStr = this.categoriesList.filter(i => i.checked).map(i => i.name).join('|');
      let subRegionStr = this.subRegionList.filter(i => i.checked).map(i => i.subRegionId).join('|');
      this.auth.assignArticles({ id: this.selectedArticle.id, memberShopCategory: categoryStr, memberShopSubRegion: subRegionStr }).subscribe((resp: ApiResponse) => {
        this.toastr.success(resp.message);
        this.commonModal.close();
        this.getArticlesList(1, '', '');
      })
    } else {
      this.toastr.error('InValid Id!');
    }
  }
  convertDate(value: number) {
    return moment.unix(value).format('MMMM D, YYYY')
  }
}
